export const CHATBOT_CHANNEL_NAME = {
    WHATSAPP: "WhatsApp",
    FACEBOOK: "Facebook",
    INSTAGRAM: "Instagram",
}

export const INSTAGRAM_CHATBOT_CONTENT_TYPE = {
    DM: "DM",
    POST: "Post",
    REEL: "Reel",
    STORY: "Story",
    INSTAGRAM_LIVE: "Instagram Live",
}

export const CHATBOT_CHANNEL_THEME = {
    [CHATBOT_CHANNEL_NAME.WHATSAPP]: {
        color: "green",
        glowColor: "green",
        headerBg: "rgba(167, 227, 176, 0.65)",
    },
    [CHATBOT_CHANNEL_NAME.INSTAGRAM]: {
        color: "rgba(225, 128, 173, 1)",
        glowColor: "rgba(225, 128, 173, 0.8)",
        headerBg: "rgba(225, 128, 173, 0.3)",
    },
    [CHATBOT_CHANNEL_NAME.FACEBOOK]: {
        color: "rgba(120, 158, 240, 1)",
        glowColor: "rgba(120, 158, 240, 1)",
        headerBg: "rgba(120, 158, 240, 0.3)",
    },
}

export const isChatbotChannel = (channelName: string | null | undefined, expectedChannelName: string) => {
    return channelName?.toLowerCase() === expectedChannelName?.toLowerCase();
};

export const isWhatsAppChannel = (channelName: string | null | undefined) => isChatbotChannel(channelName, CHATBOT_CHANNEL_NAME.WHATSAPP);
export const isInstagramChannel = (channelName: string | null | undefined) => isChatbotChannel(channelName, CHATBOT_CHANNEL_NAME.INSTAGRAM);
export const isFacebookChannel = (channelName: string | null | undefined) => isChatbotChannel(channelName, CHATBOT_CHANNEL_NAME.FACEBOOK);

export const getChatbotChannelTheme = (channelName: string | null | undefined) => {
    const matchedKey = Object.keys(CHATBOT_CHANNEL_THEME).find(
        (name) => name.toLowerCase() === channelName?.toLowerCase()
    );
    return CHATBOT_CHANNEL_THEME[matchedKey as keyof typeof CHATBOT_CHANNEL_THEME] || CHATBOT_CHANNEL_THEME[CHATBOT_CHANNEL_NAME.WHATSAPP];
};
